import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import IconButton from "@mui/material/IconButton";
import { TooltipAlways } from "./TooltipAlways";
export function IconButtonWithTooltip(props) {
    if (props.hideDisabled && props.disabled) {
        return _jsx(Fragment, {});
    }
    return (_jsx(TooltipAlways, { title: props.title, children: _jsx(IconButton, { disabled: props.disabled, type: "button", onClick: props.onClick, children: props.icon }) }));
}
//# sourceMappingURL=IconButtonWithTooltip.js.map